import { Typography } from "@mui/material";
import { ContentColumn } from "../../components/Content";

export default function PageNotFound()
{
    return <ContentColumn>
        <Typography>PageNotFound</Typography>
    </ContentColumn>
}